import { useSelector } from 'react-redux';
import {
  findActivePilotProgram,
  getPilotSelfPlanIntakeForm,
  type PilotCapability,
} from '@shared';
import { selectFeatureFlags } from '@/model/selectors';

export function useActivePilotProgram() {
  const featureFlags = useSelector(selectFeatureFlags);
  return findActivePilotProgram(featureFlags);
}

export function useIsPilotRestricted(capability: PilotCapability) {
  const program = useActivePilotProgram();
  return !!program?.restrictedCapabilities.includes(capability);
}

/**
 * The self-plan intake form that replaces "Fill Intake Form" for this advisor, or null
 * when their program doesn't offer one.
 */
export function usePilotSelfPlanIntakeForm() {
  const featureFlags = useSelector(selectFeatureFlags);
  return getPilotSelfPlanIntakeForm(featureFlags);
}
